import DataStore from './DataStore';
import { VendorAccount } from '../types/shared/VendorAccount';

let dataStore = DataStore.getInstance('app');

let VendorAccountActions = {
  updateVendorAccountById(id: string, updates: Partial<VendorAccount>) {
    let vendorAccounts = dataStore.get('vendorAccounts');
    if (vendorAccounts) {
      let oldVendorAccount = vendorAccounts.get(id);
      if (oldVendorAccount) {
        let vendorAccountUpdates = {
          ...oldVendorAccount,
          ...updates,
        };
        let newVendorAccounts = vendorAccounts.set(id, vendorAccountUpdates);
        dataStore.set('vendorAccounts', newVendorAccounts);
        return newVendorAccounts;
      }
    }
  },

  deleteVendorAccountById(id: string) {
    let vendorAccounts = dataStore.get('vendorAccounts');
    if (vendorAccounts) {
      vendorAccounts.delete(id);
      let newVendorAccounts = new Map(vendorAccounts);
      dataStore.set('vendorAccounts', newVendorAccounts);
    }
  },
};

export default VendorAccountActions;
